/**
 * User Tasks API — Mark a MANUAL-resolution action item done ("I did it").
 *
 * POST /v1/user-tasks/complete
 *
 * Keyed on the task `stableKey`. Permanent, server-side, set-once per user
 * (recorded in the shared UserItemInteraction store, itemType='user_task',
 * column completedAt). Idempotent. Only meaningful for `manual` items — `auto`
 * items disappear when their source reports them done, so the surface offers
 * "mark done" only for manual items (the endpoint 404s a complete on an auto key).
 *
 * `userId` (optional) is the subject user whose task is completed. Omitted →
 * self. Supplied & ≠ self → requires school-admin / super-admin (view-as).
 */

import { z } from 'zod'

export const CompleteUserTaskRequestSchema = z
  .object({
    stableKey: z.string().min(1),
    /** Subject user (UsersOnSchools.publicId) to act on; omit for self. */
    userId: z.string().min(1).optional()
  })
  .strict()
export type CompleteUserTaskRequest = z.infer<typeof CompleteUserTaskRequestSchema>

export const CompleteUserTaskResponseSchema = z.object({
  stableKey: z.string(),
  completedAt: z.string().datetime()
})
export type CompleteUserTaskResponse = z.infer<typeof CompleteUserTaskResponseSchema>
